import axios from 'axios';
import { apiClient, apiEndpoint } from './api.services';
import { API } from '../constants/api.constants';
import { localStorageService } from './localStorage.service';

export const getColorLibrary = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.COLOR_LIBRARY.GET}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getColorGroupLibrary = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.COLOR_LIBRARY.GET_GROUP}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getColourSupportingDocs = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.COLOR_LIBRARY.COLOUR_SUPPORTING_DOCUMENTS}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getOneColourSupportingDoc = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.COLOR_LIBRARY.GET_COLOUR_SUPPORTING_DOCUMENT}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addColorLibrary = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.COLOR_LIBRARY.CREATE}`, {
      ...data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const colourSupportingDocs = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.COLOR_LIBRARY.COLOUR_SUPPORTING_DOCUMENTS}`, data);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addColorGroupLibrary = async (data) => {
  try {
    return await apiClient.post(`${apiEndpoint}${API.COLOR_LIBRARY.EDIT_GROUP}`, {
      ...data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const addColorGroupEditLibrary = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.COLOR_LIBRARY.EDIT_GROUP}/${data.id}`, {
      params: {
        groupId: data.groupId,
        loggedInUserId: data.loggedInUserId,
        fromDetails: data.fromDetails,
      },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const editColorLibrary = async (data, id) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.COLOR_LIBRARY.PUT}/${id}`, {
      ...data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const editColorSupportingDocuments = async (data) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.COLOR_LIBRARY.COLOUR_SUPPORTING_DOCUMENTS}`, {
      ...data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const editColorGroupLibrary = async (data, id) => {
  try {
    return await apiClient.put(`${apiEndpoint}${API.COLOR_LIBRARY.EDIT_GROUP}/${id}`, {
      ...data,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteColorLibrary = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.COLOR_LIBRARY.DELETE}/${data.id}`, {
      params: {
        loggedInUserId: data.loggedInUserId,
        multipleDelete: data.multipleDelete,
      },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const deleteMultipleColorLibrary = async (params) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.COLOR_LIBRARY.DELETE}/${params.colourWayId}`, {
      data: {
        colourWayId: params.colourWayId,
        loggedInUserId: params.loggedInUserId,
        colourWayIds: params.colourWayIds,
        multipleDelete: params.multipleDelete,
      },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteUnsavedColourSupportingDocuments = async (params) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.COLOR_LIBRARY.DELETE_UNSAVED_COLOUR_SUPPORTING_DOCUMENTS}`, {
      data: { ...params },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteColourSupportingDocuments = async (params) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.COLOR_LIBRARY.COLOUR_SUPPORTING_DOCUMENTS}`, {
      data: { ...params },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteColorGroup = async (data) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.COLOR_LIBRARY.GET_GROUP}`, {
      data: {
        groupIds: data.groupIds,
        loggedInUserId: data.loggedInUserId,
      },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getColorMergedPdf = async (data) => {
  const colorId = data;
  try {
    return await apiClient.get(`${apiEndpoint}${API.COLOR_LIBRARY.MERGED_PDF_PREVIEW}`, {
      params: { colorId },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const deleteMergedDocuments = async (payload) => {
  try {
    return await apiClient.delete(`${apiEndpoint}${API.COLOR_LIBRARY.MERGED_PDF_DELETE}`, {
      params: payload,
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getColorListLibrary = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.COLOR_LIBRARY.GET_LIST}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const getColorGroupListLibrary = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.COLOR_LIBRARY.GET_GROUP_LIST}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const exportExcelService = async (data) => {
  console.log('🚀 ~ exportExcelService ~ data:', data);
  try {
    const userInfo = localStorageService.get('loggedInUserInfo');
    if (userInfo) {
      const config = {
        headers: { Authorization: `Bearer ${userInfo.token}` },
        responseType: 'arraybuffer',
        withCredentials: true,
      };
      return new Promise((resolve, reject) => {
        axios
          .post(`${apiEndpoint}${API.COLOR_LIBRARY.DOWNLOAD_COLOURWAY_LIBRARY}`, data, config)
          .then((response) => {
            const blob = new Blob([response.data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            resolve(blob);
          })
          .catch(function (error) {
            reject(error);
          });
      });
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const uploadFile = async (data) => {
  const loginFormData = new FormData();
  loginFormData.append('xls', data.xls);
  try {
    return await apiClient.post(`${apiEndpoint}${API.COLOR_LIBRARY.UPLOAD_FILE}`, loginFormData);
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchColourGroupbyPgination = async (data) => {
  try {
    return await apiClient.get(`${apiEndpoint}${API.COLOR_LIBRARY.GET_GROUP_LIST_PGINATION}`, {
      params: { ...data },
    });
  } catch (error) {
    console.error(error);
    throw error;
  }
};
